import { initDycolor } from '~';

initDycolor('fill-status', require(`${process.env.DYCOLOR_REQUIRE}./CampaignNotification.scss`)); // eslint-disable-line

export default {
  props: {
    title: String,
    description: String,
    icon: {
      type: String,
      default: 'exclamation-triangle',
    },
    link: Object,
    filled: {
      type: Boolean,
      default: false,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/campaign-notification/CampaignNotification.js